import { createRoot } from 'solid-js'
import type { GameObject3DFrameEventFunction } from '../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate'
import blankStateForEngineInit from './blankStateForEngineInit'
import { Engine } from './Engine.type'

let lastEngineId: number = 0

export default function createEngineRoot(): Engine {
  return createRoot((dispose) => {
    const gcELL: Array<() => void> = [dispose]
    const ofELL: Array<GameObject3DFrameEventFunction> = []
    const defaultState = blankStateForEngineInit()
    const engine: Engine = {
      id: ++lastEngineId,
      state: defaultState,
      ofELL() {
        return ofELL
      },
      gcELL() {
        return gcELL
      },
    }

    return engine
  })
}
